var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.kravicka.kravicka_pozadie
    ? _c("div", {
        ref: "paralaxContainer",
        domProps: {
          innerHTML: _vm._s(
            _vm.kravicka.kravicka_pozadie.herny_produkt_popis_produktu
          )
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }